import { Menu, X, ChevronLeft, ChevronRight } from 'lucide-react';
import React from 'react';
import { Button } from '@/components/ui/button';
import { useSidebar } from './SidebarContext';

export const SidebarToggle: React.FC = () => {
  const { isExpanded, toggleSidebar } = useSidebar();

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={toggleSidebar}
      className="h-8 w-8 p-0 text-header-text hover:bg-gray-200 hover:text-header-text rounded-2xl"
      aria-label={isExpanded ? 'Sidebar schließen' : 'Sidebar öffnen'}
    >
      <span className="lg:hidden">
        {isExpanded ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
      </span>

      <span className="hidden lg:block">
        {isExpanded ? (
          <ChevronLeft className="h-8 w-8 text-sidebar-foreground" />
        ) : (
          <ChevronRight className="h-8 w-8 text-sidebar-foreground" />
        )}
      </span>
    </Button>
  );
};
